var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgRiotGameIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M13.44 0a2.24 2.24 0 0 1 2.24 2.24v11.2a2.24 2.24 0 0 1-2.24 2.24H2.24A2.24 2.24 0 0 1 0 13.44V2.24A2.24 2.24 0 0 1 2.24 0h11.2ZM7 10.5l.49 1.172 3.55.928.16-1.993L7 10.5Zm1.6-7L2.8 6.354l.95 4.146h1.23l-.338-3.026h.338L5.52 10.5h1.202V6.807h.253l.462 3.693h1.567V6.023h.29l.207 4.477h1.816l.582-6.076L8.6 3.5Z",
  id: "RiotGameIcon_svg__a"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .5)",
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#3B3B3B",
  xlinkHref: "#RiotGameIcon_svg__a"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#757575",
  xlinkHref: "#RiotGameIcon_svg__a"
}))));

export default SvgRiotGameIcon;